import { useRef, useCallback, useEffect } from "react";

export const useDelay = (callback: () => void, delayMs: number) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const startDelay = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      callback();
    }, delayMs);
  }, [callback, delayMs]);

  const clearDelay = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return { startDelay, clearDelay };
};
